<template>
    <label class="c-radio" :class="{ 'is-checked': label === model }">
        <span class="t-radio__input">
            <span class="t-radio__inner"></span>
            <input :name="name" :value="label" v-model="model" class="t-radio__original" type="radio" />
        </span>
        <span class="t-radio__label">
            <slot>
                <span>{{ label }}</span>
            </slot>
        </span>
    </label>
</template>

<script>
export default {
    name: 'c-radio',
    inject: {
        RadioGroup: {
            default: ''
        }
    },
    props: {
        label: {
            type: [Boolean, String, Number],
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        value: null
    },
    computed: {
        model: {
            get() {
                // 判断value是不是来自radio-group的
                return this.isGroup ? this.RadioGroup.value : this.value
            },
            set(value) {
                this.isGroup ? this.RadioGroup.$emit('input', value) : this.$emit('input', value)
            }
        },
        isGroup() {
            return !!this.RadioGroup
        }
    }
}
</script>

<style lang="less" scoped>
.c-radio {
    color: @color-txt-normal;
    font-weight: 500;
    line-height: 1;
    position: relative;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    font-size: 14px;
    margin-right: 30px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;

    &:hover {
        .t-radio__input {
            .t-radio__inner {
                background-image: url(../../assets/rd_1.png);
            }
        }
        .t-radio__label {
            color: @color-txt-high;
        }
    }

    .t-radio__input {
        white-space: nowrap;
        cursor: pointer;
        outline: none;
        display: inline-block;
        line-height: 1;
        position: relative;
        vertical-align: middle;

        .t-radio__inner {
            width: 18px;
            height: 18px;
            position: relative;
            cursor: pointer;
            display: inline-block;
            box-sizing: border-box;
            background: url(../../assets/rd.png) center/100% no-repeat;

            &::after {
                position: absolute;
                display: none;
                left: 2px;
                top: -1px;
                content: '';
                width: 16px;
                height: 15px;
                background: url(../../assets/rd_chekd.png) center/100% no-repeat;
            }
        }

        .t-radio__original {
            opacity: 0;
            outline: none;
            position: absolute;
            z-index: -1;
            top: 0;
            left: 0px;
            right: 0;
            bottom: 0;
            margin: 0;
        }
    }

    .t-radio__label {
        font-size: 14px;
        padding-left: 10px;
        vertical-align: middle;
    }
}

.c-radio.is-checked {
    .t-radio__input {
        .t-radio__inner {
            background: url(../../assets/rd_1.png) center/100% no-repeat;

            &:after {
                display: inline-block;
            }
        }
    }

    .t-radio__label {
        color: @color-txt-high;
    }
}
</style>
